import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import ObsessiveCompulsiveTestList from "../pages/Phase-04/ObsessiveCompulsiveTest/ObsessiveCompulsiveTestList";
import {
    fetchOcdAssessments,
    deleteOcdAssessment,
    setCurrentOcdAssessment,
} from "../store/slices/ocdAssessmentsSlice";

const ObsessiveCompulsiveTest = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { ocdAssessments, isLoading, error } = useSelector(
        (state) => state.ocdAssessments
    );

    useEffect(() => {
        dispatch(fetchOcdAssessments());
    }, [dispatch]);

    const handleAdd = () => navigate("/phase04/obsessive-compulsive-test/add");

    const handleEdit = (id) => {
        const assessment = ocdAssessments.find((a) => a.id === id);
        dispatch(setCurrentOcdAssessment(assessment));
        navigate(`/phase04/obsessive-compulsive-test/edit/${id}`);
    };

    const handleDelete = (id) => {
        dispatch(deleteOcdAssessment(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <ObsessiveCompulsiveTestList
                            assessments={ocdAssessments}
                            isLoading={isLoading}
                            error={error}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default ObsessiveCompulsiveTest;
